<template>
    <p :class="classList" :style="styleList">
        <slot />
    </p>
</template>

<script>
export default {
    name: 'SrHeadline',
    props: {
        level: {
            type: [Number, String],
            default: 1,
        },
        weight: {
            type: [Number, String],
            default: 'normal',
        },
        color: {
            type: String,
            default: 'brand-blue--text',
        },
    },
    computed: {
        classList() {
            return [this.color, 'sr-headline', `sr-headline-level-${this.level}`];
        },
        styleList() {
            return {
                'font-weight': this.weight,
            };
        },
    },
};
</script>
